import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";

const alert = (props) => {
  return (
    <div className="custom_alert">
      {props.showAlert && (
        <Alert
          variant="filled"
          severity={props.severity ? props.severity : "error"}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                props.hideAlert();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {props.message
            ? props.message
            : props.showError
            ? "Error downloading CSV Data"
            : props.showDateAlert
            ? "Date Range should not be more than 7 days"
            : "No CSV Data available"}
        </Alert>
      )}
    </div>
  );
};

export default alert;
